import React from 'react';
import { Helmet } from 'react-helmet-async';

interface MetaDataProps {
  title?: string;
  description?: string;
}

const MetaData: React.FC<MetaDataProps> = ({ title, description }) => {
  const baseTitle = 'EMC';
  const fullTitle = title ? `${title} | ${baseTitle}` : baseTitle;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default MetaData;
